import React, { createContext, useRef, useState } from 'react';
import './App.css';
import RootStep, { AppView } from './components/RootStep';
import { GoToGooglePlaceIdMessage, MapIframe, MapMessageType } from './services/MapIframe';
import ProductsSelection, { Product } from './components/ProductsSelection';

export const MapIFrameContext = createContext<React.RefObject<HTMLIFrameElement> | null>(null);

function App() {

    const myIframe = useRef<HTMLIFrameElement>(null);
    const [appView, setAppView] = useState<AppView>(AppView.INTRO);
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

    const onIframeLoaded = () => {
        MapIframe.post(myIframe, {
            type: MapMessageType.TOGGLE_SEARCH_BAR,
        } as GoToGooglePlaceIdMessage);
    };

    const productsView = appView === AppView.PRODUCTS_SELECTION;
    const showMapCss = productsView ? 'hidden' : '';

    const products = productsView ?
        <div className={'flex-auto w-3/4'}>
            <ProductsSelection selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct}></ProductsSelection>
        </div>
        : <></>;

    return (
        <div className="flex">
            <iframe ref={myIframe}
                    onLoad={onIframeLoaded}
                    className={showMapCss + ' flex-auto w-3/4 h-screen'}
                    title="Map" src={process.env.REACT_APP_MAP_UI_ENDPOINT}>
            </iframe>
            {products}
            <div className="flex-auto w-1/4">
                <MapIFrameContext.Provider value={myIframe}>
                    <RootStep appView={appView} setAppView={setAppView} selectedProduct={selectedProduct}></RootStep>
                </MapIFrameContext.Provider>
            </div>
        </div>
    );
}

export interface SelectedAddress {
    label: string;
    lat: number;
    lng: number;
}

export default App;
